<template>
  <IndexCard title="专题专栏" to="/topic">
    <!-- size="large" -->
    <div class="list" v-if="categoryTopicList.length <= 3">
      <router-link
        target="_blank"
        :to="{
          name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
          query:
            item.cate_type == 2
              ? {
                  id: item.cate_id,
                  cate_type: item.cate_type,
                  name: item.name,
                }
              : {
                  id: item.cate_id,
                  cate_type: item.cate_type,
                  name: item.name,
                },
        }"
        class="item"
        v-for="(item,index) in categoryTopicList"
        :key="index + Math.random()"
      >
        <!-- pid: item.pid, -->
        <!-- cate_type 栏目类型：1=文章列表页（请求列表页接口），2=目录，意思是包含下级栏目（请求栏目列表接口） -->
        <img :src="item.image | baseImg" class="img" />
        <div class="tit">{{ item.name }}</div>
      </router-link>
    </div>
    <div class="list" v-else>
      <img
        class="sss-b"
        src="../../../assets/images/previcon.jpg"
        alt=""
        @click="iaTime"
      />
      <div class="sss">
        <div
          class="sss-a"
          :class="{ activeDec: isActive == 1, activeAbc: isActive == 2 }"
          :style="{
            width: categoryTopicList.length * 2 * 325 + 'px',
            left: left_a + 'px',
          }"
          @mouseover="mouseOver"
          @mouseleave="mouseLeave"
        >
          <router-link
            target="_blank"
            :to="{
              name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
              query:
                item.cate_type == 2
                  ? {
                      id: item.cate_id,
                      cate_type: item.cate_type,
                      name: item.name,
                    }
                  : {
                      id: item.cate_id,
                      cate_type: item.cate_type,
                      name: item.name,
                    },
            }"
            class="item"
            v-for="(item,index) in categoryTopicList"
            :key="index +Math.random()"
          >
            <!-- pid: item.pid, -->
            <!-- cate_type 栏目类型：1=文章列表页（请求列表页接口），2=目录，意思是包含下级栏目（请求栏目列表接口） -->
            <img :src="item.image | baseImg" class="img" />
            <div class="tit">{{ item.name }}</div>
          </router-link>
          <router-link
            target="_blank"
            :to="{
              name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
              query:
                item.cate_type == 2
                  ? {
                      id: item.cate_id,
                      cate_type: item.cate_type,
                      name: item.name,
                    }
                  : {
                      id: item.cate_id,
                      cate_type: item.cate_type,
                      name: item.name,
                    },
            }"
            class="item"
            v-for="(item,index) in categoryTopicList"
            :key="index +Math.random()"
          >
            <!-- pid: item.pid, -->
            <!-- cate_type 栏目类型：1=文章列表页（请求列表页接口），2=目录，意思是包含下级栏目（请求栏目列表接口） -->
            <img :src="item.image | baseImg" class="img" />
            <div class="tit">{{ item.name }}</div>
          </router-link>
        </div>
      </div>
      <img
        class="sss-c"
        src="../../../assets/images/nexticon.jpg"
        alt=""
        @click="iaTime_b"
      />
    </div>
  </IndexCard>
</template>

<script>
import IndexCard from "./IndexCard.vue";
import { getCategoryZhuanti } from "@/apis/topic";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
//
export default {
  components: {
    IndexCard,
  },
  data() {
    return {
      categoryTopicList: [],
      sss_a: "<",
      isActive: 1,
      left_a: 0,
      time_s: null,
      time_tt: false,
    };
  },
  created() {
    this.getCategoryZhuanti();
  },
  mounted() {
    this.swiperFn();
  },
  methods: {
    mouseOver() {
      clearInterval(this.time_s);
    },
    mouseLeave() {
      if (this.time_tt == false) {
        this.iaTime_b();
      } else {
        this.iaTime();
      }
    },
    iaTime() {
      this.time_tt = false;
      if (this.time_tt == false) {
        clearInterval(this.time_s);
        this.time_s = setInterval(() => {
          this.left_a += 1;
          if (this.left_a >= 0) {
            this.left_a = this.categoryTopicList.length * -325;
          }
          if (this.left_a == this.categoryTopicList.length * -325) {
            this.left_a = 0;
          }
        }, 20);
        this.time_tt = true;
      }
    },
    iaTime_b() {
      this.time_tt = true;
      if (this.time_tt == true) {
        clearInterval(this.time_s);
        this.time_s = setInterval(() => {
          this.left_a += -1;
          if (this.left_a == this.categoryTopicList.length * 325) {
            this.left_a = 0;
          }
          if (this.left_a == this.categoryTopicList.length * -325) {
            this.left_a = 0;
          }
        }, 20);
        this.time_tt = false;
      }
    },
    async getCategoryZhuanti() {
      const { data = [] } = await getCategoryZhuanti();
      this.categoryTopicList = data.slice(0, 4);
      if (this.categoryTopicList.length > 3) {
        this.time_s = setInterval(() => {
          this.left_a += -1;
          if (this.left_a == this.categoryTopicList.length * -325) {
            this.left_a = 0;
          }
        }, 20);
      }
    },
    swiperFn() {
      new Swiper(".swiper", {
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: false, // 修改swiper的父元素时，自动初始化swiper
        slidesPerView: 3,
        // spaceBetween: 30,
        // freeMode: true,
        // centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        loop: false, // 循环模式选项
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  height: 149px;

  padding: 20px 50px;
  font-size: 0;
  text-align: center;
  position: relative;
  .item {
    // width: 325px;
    // height: 195px;
    // width: 256px;
    // height: 156px;
    width: 325px;
    height: 109px;
    display: inline-block;
    font-size: 0;
    float: left;

    position: relative;
    overflow: hidden;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .tit {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      color: #fff;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      transition: transform 0.3s;
      transform: translateY(40px);
      font-size: 14px;
      font-size: var(--font-size-14);
    }
    &:hover {
      .tit {
        transform: translateY(0);
      }
    }
  }
}
.swiper-slide {
  width: 370px !important;
  margin-right: 20px;
}
.swiper-slide-active {
  // width: 325px;
}

.swiper-button-next {
  width: 37px !important;
  height: 27px !important;
}
.swiper-button-prev {
  width: 37px !important;
  height: 27px !important;
}

.sss {
  width: 100%;
  overflow: hidden;
  /* 调用动画 */
  // animation-name: move;
  /* 持续时间 */
  // animation-iteration-count: infinite;
  // animation-duration: 15s;
  position: relative;
  height: 149px;
}
.sss-a {
  display: flex;
  // animation: move 20s linear infinite;
  position: absolute;
}

.sss-a:hover {
  animation-play-state: paused;
}

.sss-b {
  position: absolute;
  left: 0;
  width: 16px;
  height: 27px;
  z-index: 999;
  top: 60px;
  left: 20px;
  background-color: #000;
  cursor: pointer;
}

.activeAbc {
  // animation: move 20s linear infinite;
}
.activeDec {
  // animation: movse 20s linear infinite;
}
.sss-c {
  position: absolute;
  width: 16px;
  height: 27px;
  z-index: 999;
  top: 60px;
  right: 20px;
  background-color: #000;
  cursor: pointer;
}
</style>